import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import apiClient from './apiClient';

const initialState = {
  branch: [],
  email: '',
  is_active: false,
  is_administrator: false,
  name_rol: '',
  names: '',
  telephone: '',
  timezone: '',
  uid_firebase: '',
  uuid: '',
  uuid_rol: '',
  uuid_subscriber: 'None',
};

const useUserLoggedStore = create(
  persist(
    (set) => ({
      ...initialState,

      setUserLogged: (userData) => set((state) => ({ ...state, ...userData })),

      clearUserLogged: () => set(initialState),

      updateUserField: (field, value) => set((state) => ({ ...state, [field]: value })),
    }),
    {
      name: 'user-logged-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

const userLoggedKeys = {
  all: ['userLogged'],
  profile: () => [...userLoggedKeys.all, 'profile'],
};

export const useUserLogged = () => {
  const queryClient = useQueryClient();
  const store = useUserLoggedStore();

  const profileQuery = useQuery({
    queryKey: userLoggedKeys.profile(),
    queryFn: async () => {
      const response = await apiClient.get('auth/profile');
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
    enabled: false,
  });

  const updateProfileMutation = useMutation({
    mutationFn: async (userData) => {
      const response = await apiClient.put('auth/profile', userData);
      return response.data;
    },
    onSuccess: (data) => {
      store.setUserLogged(data);
      queryClient.setQueryData(userLoggedKeys.profile(), data);
    },
  });

  const updateProfile = (userData) => updateProfileMutation.mutate(userData);

  return {
    ...store,
    isLoading: profileQuery.isLoading || updateProfileMutation.isPending,
    error: profileQuery.error || updateProfileMutation.error,
    updateProfile,
    refetch: profileQuery.refetch,
  };
};